import { useState } from 'react';

// https://jdudzik.medium.com/persistent-data-with-react-hooks-and-context-api-3f3f18ce947
// This hook receives two parameters:
// storageKey: This is the name of our storage that gets used when we retrieve/save our persistent data.
// initialState: This is our default value, but only if the store doesn't exist, otherwise it gets overwritten by the store.
export default function usePersistState<T>(
  storageKey: string,
  initialState: T,
): [T, (newState: T) => void] {

  // Restore the saved login before consumers choose between user and guest behaviour.
  const [state, setInternalState] = useState<T>(() => {
    const storageInBrowser = localStorage.getItem(storageKey);
    return storageInBrowser ? JSON.parse(storageInBrowser) as T : initialState;
  });

  // Create a replacement method that will set the state like normal, but that also saves the new state into the store.
  const setState = (newState: T) => {
    if (newState === null || newState === undefined) {
      localStorage.removeItem(storageKey);
    } else {
      localStorage.setItem(storageKey, JSON.stringify(newState));
    }
    setInternalState(newState);
  };

  return [state, setState];
}
